// This function takes the product image's actual size and floors / rounds / ceils it to a nearby whole, predefined number
// which has an image associated with it. It returns a string which should be used as name in the image path.
export const calcProductImageFromSize = (size: number): string => {
  const objSize =
    size < 1
      ? 1
      : size < 10
        ? Math.floor(size)
        : size < 50
          ? Math.ceil((size + 1) / 10) * 10
          : Math.ceil(size / 25) * 25;
  return objSize.toString();
};
